import { IGetPurchaseOrderHoldRequestsRequest } from 'interfaces/api-requests/get-purchase-order-hold-requests-request';

export const HOLD_REQUESTS_LIST_ACTIONS = {
  REQUEST: 'HOLD_REQUESTS_LIST_ACTIONS.REQUEST',
  SUCCESS: 'HOLD_REQUESTS_LIST_ACTIONS.SUCCESS',
  FAILURE: 'HOLD_REQUESTS_LIST_ACTIONS.FAILURE',
  CLEAR: 'HOLD_REQUESTS_LIST_ACTIONS.CLEAR',
  REMOVE_UNREAD: 'HOLD_REQUESTS_LIST_ACTIONS.REMOVE_UNREAD',
};

export function clearHoldRequestList() {
  return { type: HOLD_REQUESTS_LIST_ACTIONS.CLEAR };
}

export function getHoldRequestsListRequest(payload: IGetPurchaseOrderHoldRequestsRequest) {
  return {
    payload,
    type: HOLD_REQUESTS_LIST_ACTIONS.REQUEST
  };
}

export function getHoldRequestsListSuccess(payload) {
  return {
    payload,
    type: HOLD_REQUESTS_LIST_ACTIONS.SUCCESS
  };
}

export function getHoldRequestsListFailure(payload) {
  return {
    payload,
    type: HOLD_REQUESTS_LIST_ACTIONS.FAILURE
  };
}

export function removeHoldRequestsItemUnread(payload) {
  return {
    payload,
    type: HOLD_REQUESTS_LIST_ACTIONS.REMOVE_UNREAD
  };
}
